export default {
  meta: {
    title: '销售管理',
    url: '/stores/salemanage', // 埋点用，记录所属模块
    // eventId: '073d60a3-24c3-4e75-9a9d-841d3ad50257'
  },
};
